import { laravelAxios } from '../../../../../config/axios/laravelAxios';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import packageJson from '../../../../../../package.json';
import {
  logout as logoutAction,
  revokeToken,
} from '../../../../../store/modules/auth/actions';
import poliConfig from '../../../../../utils/poliConfig';
import CreditsCard from 'src/components/credits/available/CreditsCard';
import { useFlags } from 'flagsmith/react';

import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Icon,
} from '@polichat/flamboyant';

import { AdsLineDark } from '@poli-digital/react';
import { StarsIcon } from 'src/assets/icons/star-icon';

import { useLocation, useHistory } from 'react-router-dom';

import DarkMode from '../../header/actions/DarkMode';
import Organizations from '../../header/actions/Organizations';

import SidebarItem from './SidebarItem';
import SidebarMainIcon from './SidebarLogo';

import { connect, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ChatActions from '../../../../../store/modules/chat/actions';

import routes from '../../../../../routes/Routes';
import Avatar from '../../../profile/Avatar';

import { ToggleNotifications } from '../../header/actions/ToggleNotifications';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';
import { generateWhatsAppWebLink } from 'src/utils/whatsappLink';

function SidebarWhitelabel({ userConfig, current_customer_id }) {
  let avatarOperator;
  let nameOperator;
  let idOperator;
  let currentCustomer;
  const multiCustomers = userConfig?.customers.length > 1 ? true : false;
  const superRole = userConfig?.superRole;
  const dispatch = useDispatch();

  const wlConfig = useSelector((state) => state?.whitelabel?.config);

  const { template_billing } = useFlags(['template_billing']);

  const shouldShowCreditsCard = (() => {
    if (!template_billing) return true;

    let ids = null;

    if (typeof template_billing.value === 'string') {
      try {
        const parsed = JSON.parse(template_billing.value);
        if (Array.isArray(parsed)) {
          ids = parsed.map((id) => String(id).trim());
        }
      } catch (err) {
        return true;
      }
    } else if (Array.isArray(template_billing.value)) {
      ids = template_billing.value.map((id) => String(id).trim());
    }

    if (!ids) return true;

    if (ids.length === 0) return true;

    if (current_customer_id && ids.includes(String(current_customer_id))) {
      return true;
    }

    return false;
  })();

  const isAuvo =
    useSelector((state) => state?.whitelabel?.config?.app_title) === 'Auvo';

  const [showRoutes, setShowRoutes] = useState(routes);

  const enableAds =
    poliConfig?.ads_enable ||
    poliConfig?.ads_enable_custumer?.includes(Number(current_customer_id));

  useEffect(() => {
    if (
      routes &&
      routes.length > 0 &&
      wlConfig &&
      wlConfig.is_white_label &&
      wlConfig.buttons
    ) {
      var buttons = wlConfig.buttons;
      var _routes = [];

      routes.map((route) => {
        var canShow = buttons.find((e) => e.id === route.tag);
        if (canShow) {
          if (route.tag === 'automation') {
            if (superRole === 'adm' || superRole === 'manager') {
              _routes.push(route);
            }
          } else {
            _routes.push(route);
          }
        }
      });

      setShowRoutes(_routes);
    }
  }, [wlConfig, routes, superRole]);

  if (!userConfig || userConfig === undefined) {
    avatarOperator = '';
    nameOperator = '';
    idOperator = '';
  } else {
    nameOperator = userConfig.name;
    avatarOperator = userConfig.picture;

    idOperator = userConfig.id;
    currentCustomer = current_customer_id;
  }

  let location = useLocation();

  function isActive(path, subitens) {
    if (path === location.pathname) return true;
    if (!subitens) return false;
    return RegExp(path + '/.+', 'gi').test(location.pathname);
  }

  function isPwa() {
    return localStorage.getItem('pwa');
  }

  const [isWl, setIsWl] = useState();
  const wlState = useSelector((state) => state?.whitelabel);
  const [operatorMenu, setOperatorMenu] = useState(false);
  const [supportMenu, setSupportMenu] = useState(false);
  const [creditsData, setCreditsData] = useState({
    detachedCredits: {
      total: 0,
      used: 0,
    },
    totals: {
      balance: 0,
      used: 0,
    },
    newBillingModel: false,
    groups: {},
  });

  const [creditsMenu, setCreditsMenu] = useState(false);
  const [loginUrlReseller, setLoginUrlReseller] = useState();
  const whatsAppSupport = wlState?.config.whatsAppSupport;

  useEffect(() => {
    const _config = wlState?.config;
    const _isWl = _config?.is_white_label;
    setLoginUrlReseller(_config?.laravel_url);
    setIsWl(_isWl);
  }, [wlState]);

  const toggle = () => setOperatorMenu((prevState) => !prevState);

  const toggleMenu = () => {
    if (localStorage.getItem('@polichat/menuRetratil') === 'true') {
      document.getElementById('root').classList.add('menuRetratil');
      return true;
    }
    return false;
  };

  const [menuRetratil, handleMenuRetratil] = useState(toggleMenu());

  // Traduções para os dados de canal
  const channelWithoutNameText = useGlotaT('spa.sidebar.channelWithoutName');
  const callsText = useGlotaT('spa.sidebar.calls');
  const massBroadcastText = useGlotaT('spa.sidebar.massBroadcast');
  const aiIncludesText = useGlotaT('spa.tools.aiIncludesTranscripts');
  const ai = useGlotaT('spa.tools.ai');

  const initialChannelData = React.useMemo(
    () => [
      {
        icon: 'poli-icon pi-whatsapp-api-fill',
        label: channelWithoutNameText,
        value: 0,
      },
    ],
    [channelWithoutNameText]
  );

  const [channelData, setChannelData] = useState(initialChannelData);

  const [extraData, setExtraData] = useState([
    {
      id: 'calls',
      icon: 'poli-icon pi-phone-line',
      label: callsText,
      value: 0,
    },
    {
      id: 'massBroadcast',
      icon: <AdsLineDark />,
      label: massBroadcastText,
      value: 0,
    },
    {
      id: 'ai',
      icon: <StarsIcon />,
      label: ai,
      info: aiIncludesText,
      value: 0,
    },
  ]);

  const history = useHistory();

  const handleBuy = () => {
    setCreditsMenu(false);
    history.push('/tools/credit');
  };

  const handleCreditsToggle = () => {
    setCreditsMenu((prev) => {
      const nowOpen = !prev;
      if (nowOpen) {
        laravelAxios
          .post('/credits/balance')
          .then((res) => {
            const payload = res.data;

            const numericEntries = Object.entries(payload).reduce(
              (acc, [key, value]) => {
                if (!isNaN(Number(key)) && key !== '') {
                  acc[key] = value;
                }
                return acc;
              },
              {}
            );

            setChannelData(
              Object.entries(numericEntries)
                .filter(([key, value]) => value?.isWaba)
                .map(([key, value]) => {
                  let resValue = (value.active || 0) + (value.template || 0);
                  if (!payload.newBillingModel) {
                    resValue += value.receptive || 0;
                  }
                  return {
                    icon: value.isWaba
                      ? 'poli-icon pi-whatsapp-api-fill'
                      : 'poli-icon pi-whatsapp-line',
                    label: value.channelName,
                    value: resValue || 0,
                  };
                })
            );

            const groupedByGroupId = {};
            Object.entries(numericEntries).forEach(([key, value]) => {
              if (value?.groupId) {
                const gId = String(value.groupId);
                if (!groupedByGroupId[gId]) {
                  groupedByGroupId[gId] = {
                    groupId: gId,
                    groupTotal:
                      payload.wabaExpenditureGroups?.[gId]?.total || 0,
                    groupUsed:
                      payload.wabaExpenditureGroups?.[gId]?.usedMessage || 0,
                    channels: [],
                    wabaName:
                      payload.wabaExpenditureGroups?.[gId]?.wabaName ||
                      wabaAccountText,
                  };
                }
                groupedByGroupId[gId].channels.push({
                  icon: value.isWaba
                    ? 'poli-icon pi-whatsapp-api-fill'
                    : 'poli-icon pi-whatsapp-line',
                  label: value.channelName,
                  value: value.usedMessage || 0,
                });
              }
            });

            setExtraData((prevExtraData) => [
              { ...prevExtraData[0], value: payload.totals.call || 0 },
              { ...prevExtraData[1], value: payload.totals.trigger || 0 },
              {
                ...prevExtraData[2],
                value:
                  payload.totals.audioTranscription +
                    payload.totals.summary +
                    payload.totals.suggestion +
                    payload.totals.improveMessage || 0,
              },
            ]);

            setCreditsData({
              ...payload,
              groups: groupedByGroupId,
            });
          })
          .catch(() =>
            setCreditsData({
              totals: { balance: 0, used: 0 },
              newBillingModel: true,
              groups: {},
            })
          );
      }
      return nowOpen;
    });
  };

  function handleMenu() {
    const rootElement = document.getElementById('root');
    if (rootElement.classList.contains('menuRetratil')) {
      handleMenuRetratil(false);
      rootElement.classList.remove('menuRetratil');
      localStorage.removeItem('@polichat/menuRetratil');
    } else {
      handleMenuRetratil(true);
      rootElement.classList.add('menuRetratil');
      localStorage.setItem('@polichat/menuRetratil', true);
    }
  }

  async function logout() {
    dispatch(logoutAction());
    dispatch(revokeToken());
    window.location.href = '/login';
  }

  function myAccount() {
    if (isWl && loginUrlReseller?.toString()?.length > 2) {
      window.location.href = `${loginUrlReseller}/users/${currentCustomer}/${idOperator}/edit`;
    } else {
      window.location.href = `${poliConfig.poliAppLaravelUrl}/users/${currentCustomer}/${idOperator}/edit`;
    }
  }

  // Traduções da sidebar
  const supportText = useGlotaT('spa.sidebar.support');
  const suggestionsText = useGlotaT('spa.sidebar.suggestions');
  const helpCenterText = useGlotaT('spa.sidebar.helpCenter');
  const supportEmailText = useGlotaT('spa.sidebar.supportEmail');
  const supportWhatsappText = useGlotaT('spa.sidebar.supportWhatsapp');
  const availableCreditsText = useGlotaT('spa.sidebar.availableCredits');
  const collapseMenuText = useGlotaT('spa.sidebar.collapseMenu');
  const myAccountText = useGlotaT('spa.sidebar.myAccount');
  const logoutText = useGlotaT('spa.common.logout');
  const versionText = useGlotaT('spa.sidebar.version');
  const wabaAccountText = useGlotaT('spa.sidebar.wabaAccount');
  const whatsappChannelsText = useGlotaT('spa.sidebar.whatsappChannels');

  return (
    <>
      <SidebarMainIcon />
      <ul className="sidebarMenu whitelabel-sidebar-menu">
        {showRoutes.map((route, index) => {
          let active = isActive(route.path, route.subitens);
          let show = true;
          let path = route.path;

          if (isPwa()) {
            show = route.showPwa;
            if (route.path === '/') {
              path = '/chat';
            }
          }

          if (!enableAds && path === '/ads') {
            return <></>;
          }

          if (route.sidebarName && show) {
            return (route.needAdmin && superRole === 'adm') ||
              !route.needAdmin ? (
              <li key={index}>
                <SidebarItem
                  key={index}
                  name={route.sidebarName}
                  url={path}
                  icon={route.icon}
                  active={active}
                  title={route.title}
                  openNewPage={
                    route?.openNewPage || route?.openNewPage === false
                      ? route.openNewPage
                      : null
                  }
                />
              </li>
            ) : null;
          }

          return false;
        })}
      </ul>

      <div className="sidebarUserConfig whitelabel-sidebar-bottom">
        {!isAuvo && (
          <>
            <div className="supportMenu sidebarMenuItem">
              <Dropdown
                direction="right"
                isOpen={supportMenu}
                toggle={() => setSupportMenu((prevState) => !prevState)}
              >
                <DropdownToggle color={'link'} className="supportMenuButton">
                  <Icon icon="poli-icon pi-question-line" />
                  <span>{supportText}</span>
                </DropdownToggle>
                <DropdownMenu className="menuDropdownShow">
                  <DropdownItem
                    className="itemDropdownMenu"
                    onClick={() =>
                      window.open('https://forms.gle/f8FGaGFENdgUbo9r9')
                    }
                  >
                    <Icon
                      icon={'poli-icon pi-alerts-line'}
                      color={'var(--green-polichat)'}
                      size={25}
                      position={'relative'}
                      left={'2px'}
                    />
                    <p className="alternative">{suggestionsText}</p>
                    <Icon
                      icon={'poli-icon pi-simple-arrow-right-line'}
                      color={'var(--gray-75)'}
                      position={'relative'}
                      size={15}
                    />
                  </DropdownItem>

                  <DropdownItem
                    className="itemDropdownMenu"
                    onClick={() =>
                      window.open('https://poli.digital/central-de-ajuda/')
                    }
                  >
                    <Icon
                      icon={'poli-icon pi-info-line'}
                      color={'var(--green-polichat)'}
                      size={24}
                    />
                    <p className="alternative">{helpCenterText}</p>
                    <Icon
                      icon={'poli-icon poli-icon pi-simple-arrow-right-line'}
                      color={'var(--gray-75)'}
                      position={'relative'}
                      size={15}
                    />
                  </DropdownItem>

                  <DropdownItem
                    className="itemDropdownMenu"
                    onClick={() =>
                      window.open('mailto:contato@polichat.com.br')
                    }
                  >
                    <Icon
                      icon={'poli-icon pi-mail-line'}
                      color={'var(--green-polichat)'}
                      size={24}
                    />
                    <p className="alternative">{supportEmailText}</p>
                    <Icon
                      icon={'poli-icon poli-icon pi-simple-arrow-right-line'}
                      color={'var(--gray-75)'}
                      size={15}
                    />
                  </DropdownItem>

                  {whatsAppSupport && (
                    <DropdownItem
                      className="itemDropdownMenu"
                      onClick={() => {
                        window.open(
                          generateWhatsAppWebLink(
                            'spa.common.whatsapp.wantToKnowCRM'
                          )
                        );
                      }}
                    >
                      <Icon
                        icon={'poli-icon pi-whatsapp-line'}
                        color={'var(--green-polichat)'}
                        size={24}
                      />
                      <p className="alternative">{supportWhatsappText}</p>
                      <Icon
                        icon={'poli-icon poli-icon pi-simple-arrow-right-line'}
                        color={'var(--gray-75)'}
                        size={15}
                      />
                    </DropdownItem>
                  )}
                </DropdownMenu>
              </Dropdown>
            </div>

            <div className="operatorMenu" id={idOperator}>
              <Dropdown direction="right" isOpen={operatorMenu} toggle={toggle}>
                <DropdownToggle color={'neutral'}>
                  <Avatar
                    title={nameOperator}
                    url={avatarOperator}
                    extraClass="avatarSidebar"
                    size={30}
                  />
                  <p className="operatorName">{nameOperator}</p>
                </DropdownToggle>
                <DropdownMenu className="menuDropdownShow container__operator--menu">
                  <DropdownItem
                    className="itemDropdownMenu"
                    onClick={myAccount}
                  >
                    <Icon
                      icon={'poli-icon pi-setting-line'}
                      color={'var(--green-polichat)'}
                      size={20}
                    />
                    <p className="alternative">{myAccountText}</p>
                    <Icon
                      icon={'poli-icon poli-icon pi-simple-arrow-right-line'}
                      color={'var(--green-polichat)'}
                      position={'relative'}
                      size={20}
                    />
                  </DropdownItem>
                  <ToggleNotifications />
                  <div className="mobileTopActions">
                    {multiCustomers && (
                      <>
                        <Organizations />
                        <br />
                      </>
                    )}
                    <DarkMode />
                  </div>

                  <DropdownItem
                    className="itemDropdownMenu operatorExitPolichat"
                    onClick={logout}
                  >
                    <Icon
                      icon={'poli-icon pi-out-fill'}
                      color={'var(--red-polichat)'}
                      size={20}
                    />
                    <p className="alternative">{logoutText}</p>
                    <Icon
                      icon={'poli-icon poli-icon pi-simple-arrow-right-line'}
                      color={'var(--red-polichat)'}
                      size={20}
                    />
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
          </>
        )}

        {shouldShowCreditsCard && (
          <div className="supportMenu sidebarMenuItem sidebarMenuCredits">
            <div className="creditsMenu">
              <Dropdown
                direction="right"
                isOpen={creditsMenu}
                toggle={handleCreditsToggle}
              >
                <div className="credits-container">
                  <DropdownToggle color="invisible" className="credits-toggle">
                    <Icon
                      icon="poli-icon pi-pay-fill"
                      className="credits-icon"
                    />
                    <span className="credits-label">
                      {availableCreditsText}:&nbsp;
                      <strong className="credits-value">
                        {creditsData.newBillingModel
                          ? Math.max(
                              0,
                              (creditsData.detachedCredits?.total || 0) -
                                (creditsData.totals?.used || 0)
                            )
                          : Math.max(
                              0,
                              (creditsData.detachedCredits?.total || 0) -
                                (creditsData.totals?.trigger +
                                  creditsData.totals?.call +
                                  creditsData.totals?.audioTranscription +
                                  creditsData.totals?.summary +
                                  creditsData.totals?.suggestion +
                                  creditsData.totals?.improveMessage +
                                  creditsData.detachedCredits?.used || 0)
                            )}
                      </strong>
                    </span>
                  </DropdownToggle>
                </div>
                <DropdownMenu
                  className="menuDropdownShow container__credits--menu whitelabel-credits-dropdown"
                  style={{
                    marginLeft: menuRetratil ? '4rem' : '4rem', // Sempre 4rem para garantir visibilidade no mobile
                    borderRadius: '10px',
                    padding: '16px 16px 16px',
                    width: '300px',
                  }}
                >
                  <CreditsCard
                    billingAi={creditsData.billingAi}
                    availableCredits={creditsData.totals.balance}
                    consumedCredits={creditsData.totals.used}
                    totalCredits={
                      creditsData.newBillingModel
                        ? creditsData.detachedCredits?.total
                        : creditsData.totals.balance
                    }
                    channelTitle={whatsappChannelsText}
                    channels={channelData}
                    extras={extraData}
                    onBuy={handleBuy}
                    newBillingModel={creditsData.newBillingModel}
                    detachedCreditsTotal={creditsData.detachedCredits?.total}
                    detachedCreditsUsed={
                      creditsData.detachedCredits?.usedMessage
                    }
                    groups={creditsData.groups}
                    oldSumTypeBillingModel={
                      creditsData.totals.trigger +
                      creditsData.totals.call +
                      creditsData.totals.audioTranscription +
                      creditsData.totals.summary +
                      creditsData.totals.suggestion +
                      creditsData.totals.improveMessage
                    }
                  />
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>
        )}

        <div className="showMenuRetratil" onClick={handleMenu}>
          {menuRetratil ? (
            <Icon
              position={'relative'}
              top={'2px'}
              left={'-3px'}
              icon={'poli-icon poli-icon pi-next-line'}
            />
          ) : (
            <Icon
              position={'relative'}
              top={'2px'}
              icon={'poli-icon poli-icon pi-previous-line'}
            />
          )}
          <span>{collapseMenuText}</span>
        </div>

        <div className="showVersion">
          <span className="numberVersion">
            <span className="textVersion">
              {versionText}:
              <br />
            </span>
            {packageJson?.version}
          </span>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state, ownProps) => ({
  config: state.chat.config,
  userConfig: state?.general?.user,
  props: ownProps,
  current_customer_id: state.general?.current_customer_id,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(ChatActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SidebarWhitelabel);
